import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MantineProvider } from '@mantine/core';
import { boomPayTheme } from './Theme/theme';
import { BrowserRouter } from 'react-router-dom';
import { UserAuthContextProvider } from './Context/Userauthcontext';
import { WalletProvider } from './Context/Walletcontext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MantineProvider theme={boomPayTheme}>
      <BrowserRouter>
        <UserAuthContextProvider>
          <WalletProvider>
            <App />
          </WalletProvider>
        </UserAuthContextProvider>
      </BrowserRouter>
    </MantineProvider>

  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
